// extracted by mini-css-extract-plugin
export default {"container":"PieceRendererNoteTooltip_container__C4BLY"};